<template>
  <div v-if="store" class="relative bg-white rounded-2xl shadow-md p-6 mx-auto">
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-2">
      <StackedField label="Promotion">
        <DiscountButton
          :current-discount="store.discount?.title"
          :store-id="store.id"
          :discounts="availableDiscounts"
          @discountUpdated="$emit('discountUpdated')"
        />
      </StackedField>
      <StackedField label="Challenge">
        <ChallengeButton
          :challenges="availableChallenges"
          :store-id="store.id"
          :current-challenge-id="store.challenge?.id"
          @challengeUpdated="$emit('challengeUpdated')"
        />
      </StackedField>
    </div>
  </div>
</template>

<script>
import { StackedField } from "@estaly/ui";
import DiscountButton from "@/components/store/details/discount/DiscountButton.vue";
import ChallengeButton from "@/components/store/details/challenge/ChallengeButton.vue";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    DiscountButton,
    ChallengeButton,
    StackedField,
  },

  props: ["store"],

  computed: {
    ...mapState("discounts", { availableDiscounts: "index" }),
    ...mapState("challenges", { availableChallenges: "index" }),
  },

  async mounted() {
    await this.withLoader(async () => {
      await this.fetchDiscounts({ enabled: true });
      await this.fetchChallenges();
    });
  },

  methods: {
    ...mapActions("discounts", { fetchDiscounts: "fetchIndex" }),
    ...mapActions("challenges", { fetchChallenges: "fetchIndex" }),
    ...mapActions("backoffice", ["withLoader"]),
  },
};
</script>
